import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "block permission" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "message" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", null, "権限", -1)),
      _createElementVNode("nav", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (item, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: item.slug
            }, _toDisplayString(item.name), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selected]
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary",
          style: {"margin-left":"12px"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addPerm && _ctx.addPerm(...args)))
        }, "追加")
      ]),
      _createVNode(_component_Table, {
        data: _ctx.data,
        headers: _ctx.headers,
        buttonCols: _ctx.buttonCols,
        onDelPerm: _ctx.delPerm
      }, null, 8, ["data", "headers", "buttonCols", "onDelPerm"])
    ]),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [5]
    }, 512)
  ], 64))
}